<template>
  <section class="section pb-0 pt-0 section-components">
    <div class="py-4 bg-darker clearfix">
      <div class="container-fluid">
        <!-- Inputs (alternative) -->
        <h2 class="mb-3">
          <small class="h2">Hostels</small>
        </h2>
        <div class="row">
          <div
            class="col-lg-3 col-md-4"
            v-for="listedHostel in listedHostels"
            v-bind:key="listedHostel.num"
          >
            <b-card
              no-body
              :img-src="listedHostel.image"
              img-alt="Card image"
              class="mb-3 rounded-0"
              header-class="p-3"
            >
              <template v-slot:header>
                <b-card-title class="mb-2" v-text="listedHostel.name">Card Title</b-card-title>
                <p class="d-flex justify-content-between">
                  <span class="card-subtitle" v-text="listedHostel.location">Card Sub Title</span>
                  <span
                    class="card-subtitle"
                    v-text="listedHostel.rating +' star(s)'"
                  >Card Sub Title</span>
                </p>
              </template>
              <div class="on-img h4 pr-5" v-text="listedHostel.price"></div>
            </b-card>
          </div>
        </div>
        <a href="#" class="btn btn-default float-right mr-5">More Hostels</a>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  data() {
    return {
      listedHostels: [
        {
          num: 11,
          name: "Edi Bee Hostel",
          price: "¢200,00",
          rating: "3",
          occupancy: "Single",
          location: "Kwaprow",
          type: "Flat",
          image: '/img/hostels/edi-bee.jpg'
        },
        {
          num: 21,
          name: "Kyerewa Villa",
          price: "¢1200,00",
          rating: "2",
          occupancy: "Single",
          location: "Ayensu",
          type: "Standard",
          image: '/img/hostels/kyerewa-villa.jpg'
        },
        {
          num: 31,
          name: "Stanford Hostel",
          price: "¢2100,00",
          rating: "5",
          occupancy: "Double",
          location: "Kwaprow",
          type: "Flat",
          image: '/img/hostels/stanford.jpg'
        },
        {
          num: 41,
          name: "Sammy Otoo's Hostel",
          price: "¢50,00",
          rating: "4",
          occupancy: "Single",
          location: "Kwaprow",
          type: "Standard",
          image: '/img/hostels/sammy-otoo.jpg'
        }
      ]
    };
  }
};
</script>
<style>
</style>
